<template>
  <div :class="['select-style', { 'active' : isFilterOpen }]">
    <button type="button" class="select-button" @click="toggleFilterList()">{{ selectedTitle }}</button>
    <select aria-hidden="true">
      <option v-for="(filter, index) in filterList" :key="index">{{ filter.title }}</option>
    </select>
    <div class="select-list-scroll"  :style="`width :${filterWidth}px`" >
      <div
        class="select-list-box"
        ref="selectList"
        :style="filterHeight ? `max-height:${filterHeight > 240 ? filterHeight : 240 }px` : ''"
      >
        <ul class="list">
          <li
            v-for="(filter, index) in filterList"
            :key="`real_filter_${index}`"
            ref="filterList"
          >
            <button
              type="button"
              class="list-item-button"
              @click="changeFilter(filter)"
            >
              {{ title(filter) }}
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { parseUrl } from 'query-string'
import { PATH_NAME_PLAYER_VOD, PATH_NAME_PLAYER_MOVIE } from '@/common/resources/router.const'

export default {
  name: 'PlayerFilterList',
  props: {
    currentId: {
      type: String,
      default: '',
      required: true
    },
    filterItem: {
      type: Object,
      default: null,
      required: true
    },
    baseApi: {
      type: String,
      default: '',
      required: false // only use on vod
    }
  },
  data () {
    return {
      isFilterOpen: false,
      windowHeight: 0,
      filterWidth: 0,
      filterHeight: 0,
      selected: '',
      selectedTitle: '',
      filterList: [],
      isMovie: false
    }
  },
  methods: {
    title (filter) {
      return this.isMovie ? filter.text : filter.title || ''
    },
    getWindowHeight () {
      this.windowHeight = window.innerHeight
    },
    getFilterWidth () {
      const minWidth = 240
      const gutterRight = 20
      const gutterPlus = 2
      const gutters = gutterRight + gutterPlus

      this.$nextTick(() => {
        const filterWidthArray = this.$refs.filterList.map(item => item.scrollWidth) || []
        const longestFilterWidth = Math.max(...filterWidthArray) + gutters
        this.filterWidth = (longestFilterWidth > minWidth) ? longestFilterWidth : minWidth
      })
    },
    getFilterHeight () {
      const gutterBottom = 25
      const gutterPadding = 20
      const gutters = gutterBottom + gutterPadding
      const maxHeight = 480

      this.$nextTick(() => {
        const filterHeight = this.$refs.selectList.getBoundingClientRect().height
        const bottomRect = this.$refs.selectList.getBoundingClientRect().bottom
        const isFilterOutOfViewport = this.windowHeight - bottomRect < 0
        let height = filterHeight

        if (isFilterOutOfViewport) {
          height = filterHeight - Math.abs(this.windowHeight - bottomRect) - gutters
        }
        if (height > maxHeight) {
          height = maxHeight
        }
        this.filterHeight = height
      })
    },
    toggleFilterList () {
      this.isFilterOpen = !this.isFilterOpen
      this.getFilterHeight()
      const firstFilterOpen = (this.isFilterOpen && !this.filterWidth)
      if (firstFilterOpen) this.getFilterWidth()
    },
    changeFilter (filter) {
      const { id = '', value = '' } = filter
      this.isFilterOpen = false

      return this.isMovie ? this.goMovieDetail(value) : this.goVodDetail(id)
    },
    goVodDetail (id) {
      let api = this.baseApi.replace('{id}', id)
      const { query } = parseUrl(api)
      this.$router.push({
        name: PATH_NAME_PLAYER_VOD,
        params: {
          section: 'vod'
        },
        query: {
          programid: query.programid,
          history: query.history
        }
      })
    },
    goMovieDetail (id) {
      this.$router.push({
        name: PATH_NAME_PLAYER_MOVIE,
        params: {
          section: 'movie'
        },
        query: {
          movieid: id
        }
      })
    },
    setSelected () {
      const key = this.isMovie ? 'value' : 'id'
      const initialSelectedIndex = this.filterList.findIndex(obj => obj[key] === this.currentId)
      let selected = ''
      let selectedTitle = ''

      if (this.isMovie) {
        const { value, text } = _.get(this.filterItem, ['list', initialSelectedIndex], {})
        selected = value
        selectedTitle = text
      } else {
        const { id, title } = _.get(this.filterItem, ['seasonItemList', initialSelectedIndex], {})
        selected = id
        selectedTitle = title
      }

      this.selected = selected
      this.selectedTitle = selectedTitle
    },
    init () {
      this.isMovie = (this.$route.meta?.section === 'movie')
      this.filterList = this.isMovie
        ? this.filterItem.list
        : this.filterItem.seasonItemList

      this.setSelected()
    },
    closeFilter (event) {
      const isFilterButton = event.target.classList.contains('select-button')
      const isFilterList = event.target.classList.contains('select-list-scroll')
      if (!(isFilterButton || isFilterList) && this.isFilterOpen) {
        this.isFilterOpen = false
      }
    }
  },
  created () {
    this.init()
  },
  mounted () {
    this.getWindowHeight()
    window.addEventListener('resize', this.getWindowHeight)
    window.addEventListener('click', this.closeFilter)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.getWindowHeight)
    window.removeEventListener('click', this.closeFilter)
  },
  watch: {
    currentId () {
      this.init()
    }
  }
}
</script>
